import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 300 300",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 300 300\" overflow=\"visible\" id=\"icon-phone\">\r\n<path d=\"M247.28,221.76V24.48C247.28,10.88,236.4,0,222.8,0H77.2C63.6,0,52.72,10.88,52.72,24.48v197.28H247.28z\r\n\t M52.72,233.68v39.75c0,14.64,11.92,26.57,26.57,26.57h142.05c15.9,0,25.73-10.67,25.73-27.83v-38.49H52.72z M150,269.04\r\n\tc-5.86,0-10.46-4.6-10.46-10.46c0-5.86,4.6-10.46,10.46-10.46c5.86,0,10.46,4.6,10.46,10.46C160.46,264.22,155.86,269.04,150,269.04\r\n\tL150,269.04z M150,269.04\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/phone.svg
// module id = bDN7
// module chunks = 34